import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';
import {
  PathwayLessonLaunchUrlData,
  PathwayLessonLaunchUrlVars
} from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../gql';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

const usePathwayLessonLaunch = (
  username: string,
  zonekey: number,
  pathkey: string,
  lessonkey: string,
  resultkey: string,
  targetOrigin: string
) => {
  if (!dashboardApolloClient) {
    dashboardApolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

  const { loading, error, data } = useQuery<
    PathwayLessonLaunchUrlData,
    PathwayLessonLaunchUrlVars
  >(GraphQL.Query.GET_LESSON_LAUNCH_URL, {
    variables: {
      username,
      zonekey,
      pathkey,
      lessonkey,
      resultkey: +resultkey,
      targetOrigin
    },
    fetchPolicy: 'network-only'
  });

  return {
    loading,
    error,
    url: data?.getLessonLaunchUrl
  };
};

export default usePathwayLessonLaunch;
